/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-console */
/* eslint-disable react/no-children-prop */
import {
  makeStyles,
  RACModalCard,
  Typography,
  RACButton,
  Grid,
  CircularProgress,
  RACCOLOR,
} from '@rentacenter/racstrap';
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { storeException } from '../../../api/store';
import WarningIcon from '../../../assets/img/warning.png';
import { useCustomerPaymentSummary } from '../../../context/CustomerPaymentSummary/CustomerPaymentSummaryProvider';
import { CustomerLocationState } from '../../../types/types';
import { getSelectedStore } from '../../../utils/utils';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'left',
    marginLeft: theme.typography.pxToRem(8),
    marginRight: theme.typography.pxToRem(8),
  },
  dialogRoot: {
    '& .MuiDialogContent-root': {
      padding: '1rem',
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  dialogActions: {
    paddingRight: theme.typography.pxToRem(15),
    paddingBottom: theme.typography.pxToRem(15),
    justifyContent: 'center',
  },
  warningImg: {
    width: '7%',
  },
  justifyContentCenter: {
    justifyContent: 'center',
  },
  spacerMT4: {
    marginTop: theme.typography.pxToRem(24),
  },
  spacerMR2: {
    marginRight: theme.typography.pxToRem(8),
  },
  textCenter: {
    textAlign: 'center',
  },
  RACPOPMsg: {
    marginTop: theme.typography.pxToRem(12),
    fontFamily: 'OpenSans-regular',
    fontSize: '1rem !important',
    letterSpacing: 0,
  },
  masterLoader: {
    position: 'fixed',
    backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.6,
    zIndex: 1050,
    textAlign: 'center',
    margin: 0,
  },
  Loader: {
    display: 'block',
    position: 'fixed',
    zIndex: 1051,
    top: '50%',
    right: '50%',
  },
}));

export const RecordCheckUnmaskModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  const classes = useStyles();
  const location = useLocation<CustomerLocationState>();
  const { customerPaymentSummary: customerPaymentSummaryResponse } =
    useCustomerPaymentSummary();

  const [loader, setloader] = useState(false);

  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];
  const daysPastDue = Number(
    customerPaymentSummaryResponse?.pastDueSummary?.daysPastDue ?? 0
  );

  const NextBtnClick = async () => {
    try {
      setloader(true);
      const payload: any = {
        storeException: [
          {
            identifierId: Number(customerId),
            identifierType: 'CUSTOMER',
            storeNumber: getSelectedStore(),
            exceptionTypeRefCode: 'PIIAE',
            exceptionText: `Accessed Record Check Information: ${daysPastDue} DPD`,
          },
        ],
      };
      await storeException(payload);
      setloader(false);
    } catch (e) {
      setloader(false);
      console.error('Store Exception error:', e);
    }
  };

  const RecordCheckModalContent = () => {
    return (
      <>
        <Grid container>
          <Grid
            item
            md={12}
            style={{ textAlign: 'center', marginBottom: '10px' }}
          >
            <img
              className={classes.warningImg}
              src={WarningIcon}
              alt="Warning Icon"
            />
            <Typography
              variant={'h6'}
              style={{
                fontFamily: 'OpenSans-bold',
                fontSize: '20px',
                marginBottom: '20px',
              }}
            >
              Access to Record Check Information
            </Typography>
            <Grid
              style={{
                textAlign: 'center',
                paddingLeft: '6%',
                paddingRight: '5%',
              }}
            >
              <Typography
                variant={'body2'}
                style={{
                  lineHeight: '130%',
                  textAlign: 'left',
                  fontFamily: 'OpenSans-Regular',
                  fontSize: '15px',
                  letterSpacing: 0,
                  marginBottom: '17px',
                }}
              >
                You may <span style={{ fontWeight: 'bold' }}>ONLY</span> access
                record check information if you have verified the customer’s
                contact information has changed, which may include disconnection
                of all contact numbers and/or a move without notification.
              </Typography>
              <Typography
                variant={'body2'}
                style={{
                  lineHeight: '130%',
                  textAlign: 'left',
                  fontFamily: 'OpenSans-Regular',
                  fontSize: '15px',
                  letterSpacing: 0,
                  marginBottom: '17px',
                }}
              >
                You may only contact a reference one time, must never disclose
                account information, and must comply with all requirements of
                OPS2.05 (Past Due Contact).
              </Typography>
              <Typography
                variant={'body2'}
                style={{
                  lineHeight: '130%',
                  textAlign: 'left',
                  fontFamily: 'OpenSans-Regular',
                  fontSize: '15px',
                  letterSpacing: 0,
                  marginBottom: '25px',
                }}
              >
                By clicking “Continue,” you certify your compliance with these
                requirements.
              </Typography>
            </Grid>
            <Grid
              container
              className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
            >
              <RACButton
                className={classes.spacerMR2}
                size="small"
                variant="outlined"
                color="primary"
                onClick={onClose}
              >
                Back
              </RACButton>
              <RACButton
                size="small"
                variant="contained"
                color="primary"
                isRounded={false}
                onClick={() => {
                  onContinue();
                  NextBtnClick();
                }}
              >
                Continue
              </RACButton>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <div>
      {loader === true ? (
        <Grid className={classes.masterLoader}>
          <Grid className={classes.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      <RACModalCard
        isOpen={open}
        classes={{
          dialog: classes.dialogRoot,
        }}
        maxWidth="sm"
        children={RecordCheckModalContent()}
        closeIcon={true}
        onClose={onClose}
        borderRadius="20px"
      />
    </div>
  );
};
